module.exports = __webpack_public_path__ + "static/logo-48.498be729.png";


//////////////////
// WEBPACK FOOTER
// ./static/logos/logo-48.png
// module id = 263
// module chunks = 0